var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"automation-trigger-settings"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.t('automations-form-triggers_config-reward_reached-description'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }